<template>
  <v-layout row wrap justify-center>
    <v-flex xs12 md10 lg8>
      <v-card class="pa-4">
        <h2 class="mb-2">{{ $lang.labels.customerTrackingTitle1 }}</h2>
        <h4 class="mb-4">{{ $lang.labels.customerTrackingTitle2 }}</h4>
        <v-form v-model="valid" @submit.prevent="" style="width: 100%">
          <v-layout row wrap pb-4>
            <v-flex xs12>
              <v-text-field
                  :label="$lang.labels.firstName"
                  v-model="form.firstName"
                  name="firstName"
                  :rules="nameRules"
                  required
              ></v-text-field>
            </v-flex>
            <v-flex xs12>
              <v-text-field
                  :label="$lang.labels.lastName"
                  v-model="form.lastName"
                  name="lastName"
                  :rules="nameRules"
                  required
              ></v-text-field>
            </v-flex>
            <v-flex xs12>
              <v-text-field
                  :label="$lang.labels.phone"
                  v-model="form.phone"
                  name="phone"
                  :rules="[phoneNumberRules]"
                  required
              ></v-text-field>
            </v-flex>
            <v-flex xs12>
              <v-text-field
                  :label="$lang.labels.email"
                  v-model="form.email"
                  name="email"
                  :rules="emailRules"
                  required
              ></v-text-field>
            </v-flex>
            <v-flex xs12 md6 pr-2>
              <v-text-field
                  :label="$lang.labels.tableName"
                  v-model="form.table"
                  name="table"
                  :rules="tableRules"
                  required
              ></v-text-field>
            </v-flex>
            <v-flex xs12 md6 pl-2>
              <v-text-field
                  readonly=""
                  :label="$lang.labels.dateTime"
                  :placeholder="formatDateTime(dateTime)"
                  name="dateTime"
              ></v-text-field>
            </v-flex>
            <v-btn
                :disabled="!valid"
                type="submit"
                color="primary mx-0"
                @click="submit()"
            >{{ $lang.actions.submit }}
            </v-btn>
          </v-layout>
        </v-form>
        <v-layout row wrap>
          <v-flex xs12 md6 pr-1>
            <div class="text-xs-left" v-html="dataHtml.left"></div>
          </v-flex>
          <v-flex xs12 md6 pl-1>
            <div class="text-xs-left" v-html="dataHtml.right"></div>
          </v-flex>
        </v-layout>
      </v-card>
    </v-flex>
    <v-dialog v-model="infoDialog" v-if="infoDialog" max-width="500px">
      <v-layout row wrap justify-center class="text-xs-center" style="background-color: white">
        <v-flex xs12 pb-2>
          <v-alert
              color="success"
              class="success ma-0"
              icon="check"
              value="true"
              v-if="success"
              style="font-size: 28px">{{ success }}
          </v-alert>
          <v-alert
              color="error"
              class="err"
              icon="warning"
              value="true"
              v-if="err">{{ err }}
          </v-alert>
        </v-flex>
        <v-flex xs4 pb-2>
          <v-btn
              block
              color="info mx-0"
              @click="infoDialog = false; success = null; err = null"
          >OK
          </v-btn>
        </v-flex>
      </v-layout>
    </v-dialog>
  </v-layout>
</template>

<script>
import { mapGetters } from 'vuex';
import moment from 'moment';
import dataHtml from './terms-and-privacy/contact-tracking';
import auth from '../auth';

export default {
  name: 'ContactTracking',
  data() {
    return {
      infoDialog: false,
      success: null,
      err: null,
      valid: false,
      form: {
        firstName: '',
        lastName: '',
        phone: '',
        email: '',
        table: '',
      },
      dateTime: new Date(),
      tableRules: [
        v => !!v || this.$lang.errors.required,
      ],
      nameRules: [
        v => !!v || this.$lang.errors.nameMustHaveCharacters,
        v => (v && v.length <= 35) || this.$lang.errors.nameLess,
      ],
      emailRules: [
        v => !!v || this.$lang.errors.requiredEmail,
        // eslint-disable-next-line
        v => (v && /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(v.toLowerCase())) || this.$lang.errors.notValidEmail,
      ],
      dataHtml: null,
    };
  },
  computed: {
    ...mapGetters({
      company: 'company',
    }),
    phoneNumberRules() {
      if (this.company && (this.form.phone || this.form.phone !== '')) {
        return this.testPhoneNumberRules(this.company.address.country, this.form.phone);
      }
      return this.$lang.errors.requiredPhone;
    },
  },
  watch: {
    company: {
      handler(val) {
        if (val
            && val.address
            && val.address.country
            && val.address.country === 'UK') {
          this.$router.push('/');
        }
      },
    },
  },
  methods: {
    testPhoneNumberRules(country, phone) {
      if (!phone) return this.$lang.errors.requiredPhone;
      if (!country) return this.$lang.errors.countryRequired;
      let tempPhone = phone.replace(/\+|-|_| |\/|(|)/g, '');
      if (tempPhone.substring(0, 2) === '00') {
        tempPhone = tempPhone.substring(2, tempPhone.length);
      }
      if (tempPhone.substring(0, 2) === '43') {
        tempPhone = `0${tempPhone.substring(2, tempPhone.length)}`;
      }
      let checkPhone = /^0(6[045679][0469]){1}(-)?(1)?[^0\D]{1}\d{6,7}$/.test(tempPhone);
      if (!checkPhone) {
        checkPhone = /^[0-9]*$/.test(tempPhone) && [8, 9, 10, 11, 12, 13].includes(tempPhone.length);
      }
      return checkPhone || this.$lang.errors.notValidPhone;
    },
    formatDateTime(time) {
      return moment(time)
        .format('DD/MM/YYYY HH:mm');
    },
    submit() {
      this.$webHelper.post(`visit/${this.$route.params.resourceId}`, this.form)
        .then((res) => {
          if (!res.success) {
            this.err = res.body.statusText;
            this.infoDialog = true;
            return;
          }
          this.success = this.$lang.success.visitOk;
          this.infoDialog = true;
        });
    },
  },
  created() {
    this.dataHtml = dataHtml;
    if (auth.isLoggedIn()) {
      const userData = JSON.parse(localStorage.customerData) || {};
      this.form = {
        firstName: userData.first || '',
        lastName: userData.last || '',
        phone: userData.phone || '',
        email: userData.email || '',
        table: '',
      };
    }
    if (this.$route.params.tableName) this.form.table = this.$route.params.tableName;
  },
};
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/ContactTracking.vue